export function formatUptime(totalSeconds: number, dayShort: string): string {
  const safeTotalSeconds = Math.max(0, Math.floor(totalSeconds));

  const days = Math.floor(safeTotalSeconds / 86400);
  const hoursInDay = Math.floor((safeTotalSeconds % 86400) / 3600);
  const totalHours = Math.floor(safeTotalSeconds / 3600);
  const minutes = Math.floor((safeTotalSeconds % 3600) / 60);
  const seconds = safeTotalSeconds % 60;

  if (safeTotalSeconds < 86400) {
    return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  return `${days} ${dayShort} ${pad(hoursInDay)}:${pad(minutes)}:${pad(seconds)}`;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}
